import { __assign, __rest } from "tslib";
import React from 'react';
import cx from 'classnames';
import bcx from 'bem-classname';
import noop from '@airtm/utils/dist/utilities/noop';
import Close from '../icons/Close';
import { IconButton } from '../IconButton';
var ModalHeader = function (props) {
    var _a = props.componentClass, componentClass = _a === void 0 ? 'modal' : _a, onClose = props.onClose, className = props.className, children = props.children, smThick = props.smThick, otherProps = __rest(props, ["componentClass", "onClose", "className", "children", "smThick"]);
    var classes = cx(className, bcx(componentClass, 'header', { 'sm-thick': smThick }));
    return (React.createElement("div", __assign({}, otherProps, { className: classes }),
        children,
        React.createElement(IconButton, { icon: React.createElement(Close, null), variant: "primary", onClick: onClose, size: "sm", "data-testid": "modal-close-button" })));
};
ModalHeader.defaultProps = {
    smThick: false,
    onClose: noop,
    className: undefined,
    componentClass: undefined,
};
export { ModalHeader };
//# sourceMappingURL=ModalHeader.js.map